export const checkDOMReadyState = <T extends (...args: any[]) => any>(...fns: T[]): void => {
  const runAll = () => fns.forEach((fn) => fn());

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runAll);
  } else {
    runAll();
  }
};
